<script setup>
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  isLoading: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(['save']);
const { t } = useI18n();
</script>

<template>
  <section class="flex justify-end">
    <LaisPrimaryButton
      size="lg"
      icon="i-lucide-check"
      :is-loading="isLoading"
      :disabled="disabled"
      @click="emit('save')"
    >
      {{ t('REAL_ESTATE_COMMISSION_PLAN.ACTIONS.SAVE') }}
    </LaisPrimaryButton>
  </section>
</template>
